import React from "react";
import { useNavigate } from "react-router-dom";
import { Scan, LogOut, LayoutDashboard, Activity } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 glass border-b border-border/60">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
          <button
            data-testid="nav-logo"
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2.5 group"
          >
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary/15 border border-primary/30 group-hover:bg-primary/25 transition-colors">
              <Scan className="h-5 w-5 text-primary" />
            </div>
            <div className="text-left leading-none">
              <div className="font-mono text-lg font-extrabold tracking-tight">AetherScan</div>
              <div className="uppercase-label text-muted-foreground">Dwelling Review</div>
            </div>
          </button>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-dashboard"
              onClick={() => navigate("/dashboard")}
              className="hidden sm:flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
            >
              <LayoutDashboard className="h-4 w-4" /> Projets
            </button>
            <button
              data-testid="nav-diagnostics"
              onClick={() => navigate("/diagnostics")}
              className="hidden sm:flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
            >
              <Activity className="h-4 w-4" /> Sync
            </button>
            <div className="hidden md:flex flex-col items-end leading-none">
              <span className="text-sm font-medium">{user?.full_name}</span>
              <span className="uppercase-label text-muted-foreground">{user?.role}</span>
            </div>
            <button
              data-testid="nav-logout"
              onClick={async () => { await logout(); navigate("/login"); }}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-border text-muted-foreground hover:text-rose-400 hover:border-rose-500/40 transition-colors"
              title="Déconnexion"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">{children}</main>
    </div>
  );
};
